import 'react';
import createSvgIcon from '../../utils/createSvgIcon.esm.js';
import { jsx } from 'react/jsx-runtime';

var ArrowDropDownIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

export { ArrowDropDownIcon as default };
